import React, { useState, useEffect } from 'react';
import style from './content.module.scss';
import { Content as TContent } from '../types';
import CloseIcon from '../../../../../../../assets/svg/solo-chat/close.svg';
import FlowIcon from '../../../../../../../assets/svg/solo-chat/content-flow.svg';
import MessageIcon from '../../../../../../../assets/svg/solo-chat/content-chat.svg';
import { api } from '../../content/api';
import { useQuery, useAppAndBranchId } from '../../../hooks';
import { PreviewContent } from '../createDialog/components/PreviewContent';
import { labelMap } from '../../../../soloJourney/properties/message/components';

type Props = {
	content: TContent;
	close: () => void;
};

export function Content(props: Props) {
	const [appId, branchId] = useAppAndBranchId()
	const { content, close } = props;
	const [selectedTab, setSelectedTab] = useState<'messages' | 'suggestions'>(
		'messages',
	);
	const suggestions = content.type === 'message' ? content.suggestions ?? [] : []
	const contentIds = content.type === 'message' ? content.messages : []

	const{ data: contents, loading } = useQuery(
		() => api.getChatContentsByIds(appId, branchId, contentIds),
		contentIds.length,
		contentIds.length > 0,
	);

	useEffect(() => {
		// The "popup-root" occupies the top-right portion which prevents
		// the "close" icon from being clicked. Increasing the "root" zIndex
		// will fix this
		const root = document.getElementById('root');
		if (root) {
			root.style.position = 'relative';
			root.style.zIndex = '3';
		}
		return () => {
			if (root) {
				root.style.position = 'static';
			}
		};
	}, []);

	return (
		<div className={style.content}>
			<div className={style.header}>
				<div>
					<p className={style.title}>{content.dialogName}</p>
					<div>
						<img
							src={content.type === 'message' ? MessageIcon : FlowIcon}
							alt="content type"
						/>
						<p className={style.subTitle}>{content.name}</p>
					</div>
				</div>
				<button onClick={close}>
					<img src={CloseIcon} alt="close" />
				</button>
			</div>

			{content.type === 'flow' && (
				<div className={style.flow}>
					<p>{content.flowName}</p>
					<p>{content.nodeId}</p>
				</div>
			)}

			{content.type === 'message' && (
				<div className={style.tabs}>
					<button
						data-selected={selectedTab === 'messages'}
						onClick={() => setSelectedTab('messages')}
					>
						Messages
					</button>
					<button
						data-selected={selectedTab === 'suggestions'}
						onClick={() => setSelectedTab('suggestions')}
					>
						Suggestions
					</button>
					<div
						data-selected-tab={
							selectedTab === 'suggestions' ? 'suggestions' : 'messages'
						}
						className={style.tabHandle}
					/>
				</div>
			)}

			{selectedTab === "messages" && !loading && (
				<div className={style.list}>
					{contentIds.map(contentId => {
						const content = contents?.find(el => el.contentId === contentId)
						if(!content) {
							return null
						}
						return (
							<div key={content.contentId} className={style.contentItem}>
								<PreviewContent
									headless
									contentId={content.contentId}
									contentType={content.contentType}
									key={content.id}
									contentValue={{...content.contentValue, id: content.id}}
									remove={() => {}}
									title={
										(content.contentValue as any)[labelMap[content.contentType]]
									}
								/>
							</div>
						);
					})}
				</div>
			)}

			{selectedTab === "suggestions" && (
				<div className={style.list}>
					{suggestions.map((el: any) => {
						return (
							<div key={el.value} className={style.item}>
								<p>{el}</p>
							</div>
						);
					})}
				</div>
			)}
		</div>
	);
}
